<template>
  <div class="dict-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item prop="name" label="类型名称">
              <el-input v-model.trim="queryForm.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="code" label="唯一编码">
              <el-input v-model.trim="queryForm.code" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" style="margin-right: 6px;" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="6" :offset="4">
            <el-button type="primary" style="float: right;" @click="handleAddType">点击新增</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table">
      <el-table :data="dictList" v-loading="tableLoading" stripe border>
        <el-table-column type="index" label="序号" width="60" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="name" label="类型名称" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="code" label="唯一编码" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="sort" label="排序" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{row.status === 0 ? '正常' : '冻结'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="字典值管理" placement="top">
              <i
                class="iconfont iconcaidan1-4zidianguanli_1"
                style="margin-right: 16px;"
                @click="handleDictData(row)"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="编辑字典类型" placement="top">
              <i
                class="iconfont iconcaozuo-1xiugai_1"
                style="margin-right: 16px;"
                @click="handleEditType(row)"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <i class="iconfont iconcaozuo-2shanchu_1" @click="confirmDelete(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 新增/编辑字典类型 -->
    <el-dialog
      :title="dictDialogTitle"
      :visible.sync="dictDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
      @closed="cancelSubmit"
    >
      <el-form ref="paramsFormRef" :rules="paramsFormRules" :model="paramsForm" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="name" label="类型名称">
              <el-input v-model.trim="paramsForm.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="code" label="唯一编码">
              <el-input v-model.trim="paramsForm.code" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="sort" label="排序">
              <el-input v-model.number="paramsForm.sort" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="remark" label="备注">
              <el-input v-model.trim="paramsForm.remark" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="comfirmSubmit">确定</el-button>
      </span>
    </el-dialog>

    <!-- 字典值管理 -->
    <el-dialog
      title="字典值管理"
      :visible.sync="dictDataVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1280px"
    >
      <dict-data-manage :typeId="typeId"></dict-data-manage>
    </el-dialog>
  </div>
</template>

<script>
import dictApi from 'api/home/dictionary.js';
import DictDataManage from './component/DictDataManage';

export default {
  components: {
    DictDataManage
  },
  data() {
    return {
      total: 0,
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        name: '',
        code: ''
      },
      tableLoading: true,
      dictList: [],
      dictDialogTitle: '新增字典类型',
      dictDialogVisible: false,
      paramsForm: {
        id: '',
        name: '',
        code: '',
        sort: null,
        remark: ''
      },
      paramsFormRules: {
        name: [{ required: true, message: '请输入字典类型名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入字典类型唯一编码', trigger: 'blur' }],
        sort: [{ required: true, type: 'number', message: '请输入排序数字', trigger: 'blur' }]
      },
      btnLoading: false,
      dictDataVisible: false,
      typeId: ''
    };
  },
  created() {
    this.getDictListData();
  },
  methods: {
    // 获取字典类型列表
    getDictListData() {
      this.tableLoading = true;
      dictApi
        .getDictList(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.dictList = res.data.data.rows;
          }
          // else {
          //   this.$message.error(res.data.message);
          //   this.tableLoading = false;
          // }

          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 新增类型
    addDictType() {
      dictApi.postNewDictType(this.paramsForm).then(res => {
        if (res.data.code === 200) {
          this.dictDialogVisible = false;
          this.$message({
            message: '添加字典类型成功',
            type: 'success'
          });
          this.handleReset();
        }
        // else if (res.data.code === 2013002) {
        //   this.$message({
        //     message: '唯一编码重复，请重新输入',
        //     type: 'error'
        //   });
        // }
        this.btnLoading = false;
      });
    },
    // 编辑类型
    editDictType() {
      dictApi.postEditDictType(this.paramsForm).then(res => {
        if (res.data.code === 200) {
          this.dictDialogVisible = false;
          this.$message({
            message: '修改字典类型成功',
            type: 'success'
          });
          this.getDictListData();
        }
        // else if (res.data.code === 2013002) {
        //   this.$message({
        //     message: '唯一编码重复，请重新输入',
        //     type: 'error'
        //   });
        // }
        this.btnLoading = false;
      });
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getDictListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.getDictListData();
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getDictListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getDictListData();
    },
    // 重置表格
    resetParamsForm() {
      this.paramsForm.id = '';
      this.paramsForm.name = '';
      this.paramsForm.code = '';
      this.paramsForm.sort = null;
      this.paramsForm.remark = '';
    },
    // 点击新增类型
    handleAddType() {
      this.dictDialogTitle = '新增字典类型';
      this.dictDialogVisible = true;
    },
    // 点击编辑类型
    handleEditType(row) {
      this.paramsForm.id = row.id;
      this.paramsForm.name = row.name;
      this.paramsForm.code = row.code;
      this.paramsForm.sort = row.sort;
      this.paramsForm.remark = row.remark;
      this.dictDialogTitle = '编辑字典类型';
      this.dictDialogVisible = true;
    },
    // 取消新增/编辑
    cancelSubmit() {
      this.dictDialogVisible = false;
      this.$refs.paramsFormRef.resetFields();
      this.resetParamsForm();
    },
    // 确定新增/编辑
    comfirmSubmit() {
      this.btnLoading = true;
      this.$refs.paramsFormRef.validate(valid => {
        if (!valid) {
          this.btnLoading = false;
          return;
        }
        // 无 id 为新增， 有 id 为编辑
        if (!this.paramsForm.id) {
          this.addDictType();
        } else {
          this.editDictType();
        }
      });
    },
    // 删除字典类型
    confirmDelete(row) {
      this.$confirm(`待删除字典类型名称 —— “${row.name}”`, `确定删除此条字典类型？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          dictApi
            .postDeleteDictType({
              id: row.id
            })
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.handleReset();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
    },
    //  字典值管理
    handleDictData(row) {
      this.typeId = row.id;
      this.dictDataVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.dict-container {
  padding: 16px;

  .query-nav {
    height: 40px;
  }

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
